import React, {useState,useCallback, useEffect} from 'react';
import service from '../../../services/campanhas';
import { date2Front } from '../../../utils/converts';
import Listagem from './Listagem';

const RecebimentosListagem = props => {

    const config = {
        columns: [
            { label: "Campanha", field: "codigo" },
        ],
        pagination: {
            limit: 30
        },
        sort: '-dataInicio',
        search: [
            { label:'Código', field: 'codigo', operators: ['contains', 'not_contains'] }
        ]
    }

    const [registros, setRegistros] = useState({ rows: [], total: 0 });
    const [loadingList, setLoadingList] = useState(true);

    const getList = useCallback(async (params, skip) => {
        setLoadingList(true);
        const result = await service.getList({ params, sort: config.sort }, skip, config.pagination.limit);
        setLoadingList(false);
        setRegistros(result);
    }, [config.pagination.limit, config.sort]);

    const upsert = async (obj, id) => {
        setLoadingList(true);
        const result = await service.upsert(obj, id);
        setLoadingList(false);
        return result;
    }

    const reorder = async body => {
        await service.reorder(body);
    }

    useEffect(() => {
        getList([], 0);
    }, [getList]);

    return (
        <>
            <Listagem registros={registros} service={{ getList, upsert, reorder }} config={config} loadingList={loadingList} rota="recebimentos" />
        </>
    )
}

export default RecebimentosListagem;